/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { SmsEnrollmentResponseFragment } from './smsEnrollmentFragment';
import { gql } from '@apollo/client';
import { SmsEnrollmentResponseFragmentDoc } from './smsEnrollmentFragment';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SendSmsEnrollmentMutationVariables = Types.Exact<{
  mobilePhoneId: Types.Scalars['ID'];
}>;


export type SendSmsEnrollmentMutation = (
  { __typename?: 'Mutation' }
  & { sendSmsEnrollment: Types.Maybe<(
    { __typename?: 'SmsEnrollmentResult' }
    & SmsEnrollmentResponseFragment
  )> }
);


export const SendSmsEnrollmentDocument = gql`
    mutation sendSmsEnrollment($mobilePhoneId: ID!) {
  sendSmsEnrollment(mobilePhoneId: $mobilePhoneId) {
    ...SmsEnrollmentResponse
  }
}
    ${SmsEnrollmentResponseFragmentDoc}`;
export type SendSmsEnrollmentMutationFn = Apollo.MutationFunction<SendSmsEnrollmentMutation, SendSmsEnrollmentMutationVariables>;

/**
 * __useSendSmsEnrollmentMutation__
 *
 * To run a mutation, you first call `useSendSmsEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsEnrollmentMutation, { data, loading, error }] = useSendSmsEnrollmentMutation({
 *   variables: {
 *      mobilePhoneId: // value for 'mobilePhoneId'
 *   },
 * });
 */
export function useSendSmsEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsEnrollmentMutation, SendSmsEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsEnrollmentMutation, SendSmsEnrollmentMutationVariables>(SendSmsEnrollmentDocument, options);
      }
export type SendSmsEnrollmentMutationHookResult = ReturnType<typeof useSendSmsEnrollmentMutation>;
export type SendSmsEnrollmentMutationResult = Apollo.MutationResult<SendSmsEnrollmentMutation>;
export type SendSmsEnrollmentMutationOptions = Apollo.BaseMutationOptions<SendSmsEnrollmentMutation, SendSmsEnrollmentMutationVariables>;